<template>
  <header>
    <div class="header">
      <!--Logo-->
      <div class="header-left">
        <a
          href="javascript:void(0)"
          @click.prevent
          class="logo"
          v-if="userType == userTypeMainAdmin || logo"
        >
          <img
            :src="
              userType == userTypeMainAdmin ? '/static/BookWizDark.png' : logo
            "
            width="40"
            height="40"
            alt=""
          />
        </a>
      </div>
      <!--/Logo-->

      <!-- Toggle button -->
      <a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar">
        <span class="bar-icon">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </a>
      <!-- /Toggle button -->

      <!-- Toggle button mobile -->
      <a id="mobile_btn" class="mobile_btn" href="#sidebar">
        <i class="fa fa-bars"></i>
      </a>
      <!-- /Toggle button mobile -->

      <!-- Header Title -->
      <div class="page-title-box">
        <h3>Class Booking System</h3>
      </div>
      <!-- /Header Title -->

      <!-- User Account Menu -->
      <ul class="nav user-menu">
        <li
          class="nav-item login-status"
          v-if="userType == userTypeInstructorSchoolAdmin"
        >
          <a class="nav-link">{{
            isSchoolAdminPage
              ? "You are logged in as the School Admin"
              : "You are logged in as the Instructor"
          }}</a>
        </li>
        <li class="nav-item dropdown has-arrow main-drop">
          <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
            <span><i class="fas fa-user-circle mr-1"></i>{{ name }}</span>
          </a>
          <div class="dropdown-menu">
            <router-link
              v-if="userType == userTypeInstructorSchoolAdmin"
              class="dropdown-item"
              :to="{
                name: isSchoolAdminPage
                  ? 'instructorMySchedule'
                  : 'schoolAdminInstructorList',
              }"
            >
              {{
                isSchoolAdminPage
                  ? "View as Instructor instead"
                  : "View as School Admin instead"
              }}
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{ name: changePasswordPage }"
            >
              Change Password
            </router-link>
            <router-link
              v-if="userType == userTypeMainAdmin"
              class="dropdown-item"
              :to="{ name: 'mainAdminPublicHoliday' }"
            >
              Public Holidays
            </router-link>
            <a
              class="dropdown-item"
              href="javascript:void(0)"
              @click.prevent="logout"
            >
              Logout<i class="fas fa-sign-out-alt ml-1"></i>
            </a>
          </div>
        </li>
      </ul>
      <!-- /User Account Menu -->

      <!-- Mobile Menu -->
      <div class="dropdown mobile-user-menu">
        <a
          href="#"
          class="nav-link dropdown-toggle"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa fa-ellipsis-v"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <router-link
            v-if="userType == userTypeInstructorSchoolAdmin"
            class="dropdown-item"
            :to="{
              name: isSchoolAdminPage
                ? 'instructorMySchedule'
                : 'schoolAdminInstructorList',
            }"
          >
            {{
              isSchoolAdminPage
                ? "View as Instructor instead"
                : "View as School Admin instead"
            }}
          </router-link>
          <router-link class="dropdown-item" :to="{ name: changePasswordPage }">
            Change Password
          </router-link>
          <router-link
            v-if="userType == userTypeMainAdmin"
            class="dropdown-item"
            :to="{ name: 'mainAdminPublicHoliday' }"
          >
            Public Holidays
          </router-link>
          <a
            class="dropdown-item"
            href="javascript:void(0)"
            @click.prevent="logout"
          >
            Logout<i class="fas fa-sign-out-alt ml-1"></i>
          </a>
        </div>
      </div>
      <!-- /Mobile Menu -->
    </div>
  </header>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      name: "",
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
    };
  },
  computed: {
    logo() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.SchoolLogo;
    },
    userType() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.UserType;
    },
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
    isSchoolAdminPage() {
      return this.$route.path.includes("/schooladmin/");
    },
    changePasswordPage() {
      if (this.userType == this.userTypeMainAdmin)
        return "mainAdminChangePassword";
      else if (this.userType == this.userTypeSchoolAdmin)
        return "schoolAdminChangePassword";
      else if (this.userType == this.userTypeInstructor)
        return "instructorChangePassword";
      else if (this.userType == this.userTypeInstructorSchoolAdmin) {
        if (this.isSchoolAdminPage) return "schoolAdminChangePassword";
        else return "instructorChangePassword";
      } else if (this.userType == this.userTypeStudent)
        return "studentChangePassword";
      else return "otherChangePassword";
    },
  },
  methods: {
    logout() {
      this.$store.state.isLoading = true;
      API.common
        .deleteToken({ Token: this.token })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data == true) {
            window.location =
              this.userType == this.userTypeMainAdmin
                ? "/mainadmin/login"
                : "/login";
            localStorage.removeItem("cbstoken");
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    toggleSidebar() {
      let expandSidebar = this.$store.state.expandSidebar;
      this.$store.state.expandSidebar = !expandSidebar;
    },
  },
  created() {
    let data = JSON.parse(localStorage.getItem("cbstoken"));
    if (data) this.name = data.Name;
  },
  mounted() {
    // Variables declarations
    var $wrapper = $(".main-wrapper");

    $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function () {
      $wrapper.toggleClass("slide-nav");
      $(".sidebar-overlay").toggleClass("opened");
      // $("html").addClass("menu-opened");
      // $("#task_window").removeClass("opened");
      $("html").toggleClass("menu-opened");
      $("#task_window").toggleClass("opened");
      return false;
    });
    $(".sidebar-overlay").on("click", function () {
      $("html").removeClass("menu-opened");
      $(this).removeClass("opened");
      $wrapper.removeClass("slide-nav");
      $(".sidebar-overlay").removeClass("opened");
      $("#task_window").removeClass("opened");
    });

    $(document).on("click", ".top-nav-search .responsive-search", function () {
      $(".top-nav-search").toggleClass("active");
    });

    $(".sidebar-menu ul li:not(.submenu) a").click(function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $wrapper.removeClass("slide-nav");
    });
  },
};
</script>

<style scoped>
.dropdown-menu.show {
  margin-top: 0;
  margin-right: -5px;
}
.login-status > a:hover {
  cursor: default;
  background-color: unset !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/Header.vue